import {
  Text,
  Box,
  ContentBlock,
  Columns,
  Column,
  Stack,
} from 'braid-design-system';
import React from 'react';

import { CustomHeading } from './CustomHeading';

import * as style from './Testinmonial.css';

export const Testimonial = () => {
  const contents = [
    {
      content:
        '“The customer support has been amazing. After dealing with so many brokers who never got back to me I turned to Seek and my account manager was on top of everything. We got a result within 2 weeks on one of our businesses. Thank you so much for the work you do to sell our vision.”',
      name: 'Bec',
      client: 'Business owner',
    },
    {
      content:
        "“Initially tried to sell it myself on socials and Facebook but didn't get real interest. Once I signed up with SEEK Business I was getting messages of interest everyday. I sold the business within 2-3 weeks.”",
      name: 'Stephanie',
      client: 'PeekyMe',
    },
    {
      content:
        '“I have bought and sold several businesses via SEEK Business. I’m always impressed with how much interest and demand there is, and that’s where I think SEEK Business does a great job.”',
      name: 'Tom',
      client: 'Discount Lighting',
    },
  ];

  return (
    <ContentBlock>
      <Box padding="large" background="surface">
        <Stack space="large">
          <Box textAlign="center">
            <CustomHeading semanticLevel="h2" mobileLevel="1" tabletLevel="2">
              Don&apos;t just take our word for it. Here&apos;s what our
              seller&apos;s have to say.
            </CustomHeading>
          </Box>

          <Columns space="small" collapseBelow="tablet">
            {contents.map((c, index) => (
              <Column key={index}>
                <Box
                  display="flex"
                  paddingX="small"
                  boxShadow="medium"
                  justifyContent="spaceBetween"
                  flexDirection="column"
                  className={style.cards.container}
                >
                  <Box paddingBottom="medium">
                    <Text>
                      <i>{c.content}</i>
                    </Text>
                  </Box>

                  <Stack space="small">
                    <Text weight="strong">{c.name}</Text>
                    <Text weight="strong">{c.client}</Text>
                  </Stack>
                </Box>
              </Column>
            ))}
          </Columns>
        </Stack>
      </Box>
    </ContentBlock>
  );
};
